import React, { useState, useEffect } from "react";
import classNames from "classnames/bind";
import { motion, AnimatePresence } from "framer-motion";
import { Link, useLocation } from "react-router-dom";

// icons
import {
  HalfMoon,
  EventMap,
  SearchIcon,
  BellOutline,
  Plus,
} from "src/assets/icons";

// styles
import styles from "./BottomBar.module.scss";
const cx = classNames.bind(styles);

let YOldValue = 0;
let YNewValue = 0;
// let timer = null;
// let flag = true;
let offset = "80px";

const BottomBar = ({ handleClick }) => {
  const location = useLocation();

  const [show, setShow] = useState(true);
  const [actvieIndex, setActiveIndex] = useState(1);

  useEffect(() => {
    if (location) {
      if (location.pathname === "/") setActiveIndex(1);
      else if (location.pathname === "/map") setActiveIndex(2);
      else if (location.pathname === "/search") setActiveIndex(3);
    }
  }, [location]);

  useEffect(() => {
    window.addEventListener("scroll", listenToScroll);

    return () => window.removeEventListener("scroll", listenToScroll);
  }, []);

  const listenToScroll = () => {
    YNewValue = window.pageYOffset;
    if (YNewValue > YOldValue) {
      setShow(false);
      offset = "30px";
    } else {
      setShow(true);
      offset = "80px";
    }
    YOldValue = YNewValue;

    // bottom offset of plane widget
    document.documentElement.style.setProperty("--bottom-offset", `${offset}`);
  };

  // const listenToScroll = () => {
  //   if (timer !== null) {
  //     if (flag) {
  //       offset = "30px";

  //       flag = false;
  //       setShow(false);
  //     }
  //     clearTimeout(timer);
  //   }

  //   timer = setTimeout(() => {
  //     if (!flag) {
  //       flag = true;
  //       setShow(true);

  //       // bottom offset of plane widget
  //       offset = "80px";
  //       document.documentElement.style.setProperty(
  //         "--bottom-offset",
  //         `${offset}`
  //       );
  //     }
  //   }, 150);

  //   // bottom offset of plane widget
  //   document.documentElement.style.setProperty("--bottom-offset", `${offset}`);
  // };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100 }}
          animate={{ y: 0, transition: { duration: 0.35, type: "tween" } }}
          exit={{
            y: 100,
            transition: { delay: 0.1, duration: 0.25, type: "tween" },
          }}
          className={cx("bottom-bar-root")}
          id="bottom-bar"
        >
          <div className={cx("bar-wrapper")}>
            <div className={cx("section")}>
              <Link
                to="/"
                className={cx("icon-wrapper", "home-icon", {
                  active: actvieIndex === 1,
                })}
              >
                <HalfMoon />
                <span>Home</span>
              </Link>
              <Link
                to="/map"
                className={cx("icon-wrapper", "map-icon", {
                  active: actvieIndex === 2,
                })}
              >
                <EventMap />
                <span>Event Map</span>
              </Link>
            </div>
            <div className={cx("section", "to-end")}>
              <Link
                to="/search"
                className={cx("icon-wrapper", { active: actvieIndex === 3 })}
                onClick={(e) => {
                  e.preventDefault();
                  alert("comming soon.");
                }}
              >
                <SearchIcon />
                <span>Search</span>
              </Link>
              <div
                className={cx("icon-wrapper", "notify-icon")}
                onClick={handleClick}
              >
                <BellOutline />
                <span>Notification</span>
                {/* <span className={cx("count")}>2</span> */}
              </div>
            </div>
            {/* <motion.div
              initial={{ x: "-50%", y: 100 }}
              animate={{
                x: "-50%",
                y: "-20%",
                transition: { delay: 0.3, duration: 0.3 },
              }}
              exit={{ x: "-50%", y: 100, transition: { duration: 0.2 } }}
              className={cx("fab-btn")}
            >
              <Plus />
            </motion.div> */}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default BottomBar;
